/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import { lightGreen } from "@mui/material/colors";
import { alpha, styled } from "@mui/material/styles";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { blue, red, yellow, green } from "@mui/material/colors";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
} from "@mui/x-data-grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import ModalEditIpAddress from "../components/ModalEditIpAddress";
// import Footer from '../components/Footer'
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../src/store/userSilce";
// import { Typography} from "@mui/material";
import { useDispatch } from "react-redux";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { internalIpV6, internalIpV4 } from "internal-ip";
import FileReaderComponent from '../components/FileReaderComponent'
import DownloadTxtButtonComponent from '../components/DownloadTxtButtonComponent'
import * as XLSX from 'xlsx';




const theme = createTheme({
  palette: {
    primary: {
      main: red[500],
    },
    secondary: {
      main: yellow[500],
    },
    third: {
      main: blue[800],
    },
  },
});


const Companys = [
  "ศบพ.",
  "ศฮพ.",
  "ศกอ.",
  "สพร.ทอ.",
  "สคม.ทอ.",
  "สลก.ทอ.",
  "สบ.ทอ.",
  "กพ.ทอ.",
  "ขว.ทอ.",
  "ยก.ทอ.",
  "กบ.ทอ.",
  "กร.ทอ.",
  "ทสส.ทอ.",
  "สปช.ทอ.",
  "กง.ทอ.",
  "จร.ทอ.",
  "สตน.ทอ.",
  "สนภ.ทอ.",
  "สธน.ทอ.",
  "ศซบ.ทอ.",
  "สบน.ทอ.",
  "คปอ.",
  "อย.",
  "รร.การบิน",
  "บน.1",
  "บน.2",
  "บน.3",
  "บน.4",
  "บน.5",
  "บน.7",
  "บน.6",
  "บน.23",
  "บน.21",
  "บน.41",
  "บน.46",
  "บน.56",
  "ศปอว.ทอ.",
  "พธ.ทอ.",
  "ชอ.",
  "สอ.ทอ.",
  "สพ.ทอ.",
  "พอ.",
  "ขส.ทอ.",
  "ชย.ทอ.",
  "ศซว.ทอ.",
  "ยศ.ทอ.",
  "รร.นนก.",
  "ศวอ.ทอ.",
  "สก.ทอ.",
  "สน.ผบ.ดม.",
  "สวบ.ทอ.",
];

const GreenSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: lightGreen[500],
    "&:hover": {
      backgroundColor: alpha(
        lightGreen[500],
        theme.palette.action.hoverOpacity
      ),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: lightGreen[500],
  },
}));

function ContentPageSettingWeb() {



  const columns = [
    {
      field: "id",
      headerName: "ลำดับ",
      width: 50,
      valueGetter: (params) => params.api.getRowIndex(params.row.ipaddr) + 1,
    },
    { field: "office", headerName: "หน่วยงาน", width: 300 },
    { field: "ipaddr", headerName: "IP Address", width: 300 },
    {
      field: "status",
      headerName: "สถานะการใช้งาน",
      width: 300,
      renderCell: (params) => {
        const handleChangeStatus = (event,ipaddr) => {
          // setCheckstatus(!checkstatus);
          // setClickUpDateAccess(!clickUpDateAccess);
          setIpStatus((prevState) => ({
            ...prevState,
            [ipaddr]: checked
          }));
      
          const checked = event.target.checked
          const ipupdate = ipaddr
          setCheckstatus(checked)
          // console.log("checked",checked)
          var configs = {
            method: "PUT",
            url: process.env.REACT_APP_API_URL + `/UpdateStatus`,
            headers: {
              authtoken: "bearer " + token,
            },
            data: {
              checked: checked,
              ipupdate: ipupdate,
            },
          };
    
          axios(configs)
            .then((res) => {
              // console.log(res.data)
              if (res.data === "ok200") {
                setAlerts(true);
                toast.success("แก้ไขสถานะการใช้งานเรียบร้อย");



                // setInterval(() => {
                //   navigate(0);
                // }, 1000);
              } else {
                setAlerts(true);
                toast.error("ไม่สามารถแก้ไขสถานะการใช้งาน");
              }
    
              // navigate(0);
            })
            .catch((err) => {
              if (err.response.status === 401) {
                dispatch(logout());
                navigate("/notfound404", {
                  state: {
                    statusCode: err.response.status,
                    txt: err.response.data,
                  },
                });
              } else if (err.response.status === 404) {
                dispatch(logout());
                navigate("/notfound404", {
                  state: {
                    statusCode: err.response.status,
                    txt: err.response.data,
                  },
                });
              }
              console.log("getPubrelContents: ", err);
            });

        };
        
        return (
          <>
         <strong>
         <FormControlLabel
           sx={{ margin: '5px' }}
           control={
             <GreenSwitch
              //  checked={params.row.status === 0 ? false  : true}
              checked={ipStatus[params.row.ipaddr]}
               onChange={(event) =>
                handleChangeStatus(event, params.row.ipaddr)
              }
             
             />
           }
           label={params.row.status === 0 ? 'ระงับการใช้งาน'  : 'เปิดการใช้งาน'}
         />
       </strong>
          </>
        )
      }
     
     
     
    },
    {
      field: "manage",
      headerName: "การจัดการ",
      width: 400,
      renderCell: (params) => {

        return (
          <>
        <strong>
        <ModalEditIpAddress
          office={params.row.office}
          ipaddr={params.row.ipaddr}
        />

        <ThemeProvider theme={theme}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginLeft: 16 }}
            startIcon={<DeleteForeverIcon />}
           
            onClick={(event) =>
              handleClickDeleteip(event, params.row.ipaddr)
            }
          >
            DELETE
          </Button>
        </ThemeProvider>
      </strong>  
          </>
        )
        
      }
       
      ,
    },
  ];

  const columnsSave = [
    { field: "id", headerName: "ลำดับ", width: 50, valueGetter: (params) => params.api.getRowIndex(params.row.usagerecordid) + 1, },
    { field: "usagedate", headerName: "วดป.", width: 200 },
    { field: "usremail", headerName: "Email", width: 200 },
    { field: "usrlogintime", headerName: "เวลาเข้าสู่ระบบ", width: 200 },
    { field: "usrlogouttime", headerName: "เวลาออกจากระบบ", width: 200 },
    {
      field: "lastusagemenu",
      headerName: "เมนูสูดท้ายที่ใช้งานก่อนออกจากระบบ",
      width: 300,
    },
  ];


  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));
  const [ipaddress, setIpAddress] = useState("");
  const [getIps, setGetIps] = useState([]);
  // });
  const dispatch = useDispatch();
  const { user } = useSelector((state) => (state.user));
  const token = user.token;
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState(false);
  
  const [getlogIps, setGetLogIps] = useState([]);
  const [getaccess, setGetAccess] = useState([]);
  const [open, setOpen] = useState(false);
  const [clickUpDate, setClickUpDate] = useState(false);
  const [clickUpDateAccess, setClickUpDateAccess] = useState(false);
  // const [result, setResult] = useState(false)
  const [ipStatus, setIpStatus] = useState({});

  
  const [checkstatus, setCheckstatus] = useState(false);
  const [office, setOffice] = useState("");
  const [ipaddr, setIpaddr] = useState("");
  const userLogin = user;
 
  const [openConfirm, setOpenConfirm] = useState(false);

  

  const result = getIps.every(item => {
      return (item.status === 0 && item.ipaddr !== ipaddress) || (item.status === 1 && item.ipaddr === ipaddress);
    });

    
  // console.log(`result`,result);
  const filteredData = getaccess.map(item => {
    if ((item.usrtypeid === "USR01" || item.usrtypeid === "USR02") && item.status === "1") {
        return {...item, status: "1000"};
    }
    return item;
}).filter(item => item.status === "1000");


const filteredDataLock = getaccess.map(item => {
  if ((item.usrtypeid === "USR01" || item.usrtypeid === "USR02") && item.status === "1000") {
      return {...item, status: "1"};
  }
  return item;
}).filter(item => item.status === "1");
  

const hasStatus1000 = getaccess.some(item => (item.usrtypeid === "USR01" || item.usrtypeid === "USR02") && item.status === "1000");
// const hasStatus1 = getaccess.some(item => (item.usrtypeid === "USR01" || item.usrtypeid === "USR02") && item.status === "1");


const allStatus1 = getIps.every(item => item.status === 1);
// console.log("allStatus1",allStatus1);

// const allstatus = allStatus1 === true ? false : true;


const checked = hasStatus1000 === true ? true : false;

// console.log("clickUpDate",clickUpDate)

const handleChange = () => {
  setClickUpDate((prevChecked) => !prevChecked);
  if (clickUpDate === true) {
    var configs = {
      method: "PUT",
      url: process.env.REACT_APP_API_URL + `/updateAccess`,
      headers: {
        authtoken: "bearer " + token,
      },
      data: {
        filteredData: filteredData,
      },
    };
    axios(configs)
      .then((res) => {
        if (res.data === "ok200") {
          setAlerts(true);
          toast.success("แก้ไขสถานะการใช้งานเรียบร้อย");
          
          // เพิ่มโค้ดที่ต้องการให้ทำหลังจากการอัพเดทข้อมูลเรียบร้อยตรงนี้
          // ตัวอย่างเช่น:
          // doSomethingElse();
        } else {
          setAlerts(true);
          toast.error("ไม่สามารถแก้ไขสถานะการใช้งาน");
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        }
        console.log("getPubrelContents: ", err);
      });
  } else {
    var configss = {
      method: "PUT",
      url: process.env.REACT_APP_API_URL + `/updateLockAccess`,
      headers: {
        authtoken: "bearer " + token,
      },
      data: {
        filteredDataLock: filteredDataLock,
      },
    };
    axios(configss)
      .then((res) => {
        if (res.data === "ok200") {
          setAlerts(true);
          toast.success("แก้ไขสถานะการใช้งานเรียบร้อย");
          
          // เพิ่มโค้ดที่ต้องการให้ทำหลังจากการอัพเดทข้อมูลเรียบร้อยตรงนี้
          // ตัวอย่างเช่น:
          // doSomethingElse();
        } else {
          setAlerts(true);
          toast.error("ไม่สามารถแก้ไขสถานะการใช้งาน");
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        }
        console.log("getPubrelContents: ", err);
      });
  }
};



  internalIpV4()
    .then((ipAddress) => {
      // ค่าที่ได้คือ "10.107.209.28" หรืออะไรก็ตามที่ Promise resolve
      setIpAddress(ipAddress);
    })
    .catch((error) => {
      console.error(error); // ถ้ามีข้อผิดพลาดในการประมวลผล Promise
    });
  const handleChangeoffice = (event) => {
    setOffice(event.target.value);
  };
  const handleChangeipaddr = (event) => {


    setIpaddr(event.target.value);
  };

  const handleClickDeleteip = (event,ipaddr) => {

  var configs = {
    method: "DELETE",
    url: process.env.REACT_APP_API_URL + `/DeleteIp`,
    headers: {
      authtoken: "bearer " + token,
    },
    data: {
     
      ipdelete: ipaddr,
    },
  };

  axios(configs)
    .then((res) => {
      // console.log(res.data)
      if (res.data === "ok200") {
        setAlerts(true);
        toast.success("ลบipเรียบร้อย");
        setInterval(() => {
          navigate(0);
        }, 1000);
      } else {
        setAlerts(true);
        toast.error("ไม่สามารถลบipได้");
      }

      // navigate(0);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        dispatch(logout());
        navigate("/notfound404", {
          state: {
            statusCode: err.response.status,
            txt: err.response.data,
          },
        });
      } else if (err.response.status === 404) {
        dispatch(logout());
        navigate("/notfound404", {
          state: {
            statusCode: err.response.status,
            txt: err.response.data,
          },
        });
      }
      console.log("getPubrelContents: ", err);
    });
  };

  
  const handleClickOpen = () => {
    setOpen(true);
  };


  // const [checkeds, setCheckeds] = useState(false);

const handleDeleteLog = (e,deletelog) => {
  // console.log("deleteLog: ",deletelog);
  if(deletelog === 'Delete'){
    var configs = {
      method: "DELETE",
      url: process.env.REACT_APP_API_URL + `/DeleteAllLog`,
      headers: {
        authtoken: "bearer " + token,
      },
      
    };
    axios(configs)
    .then((res) => {
      // console.log(res.data)
      if (res.data === "ok200") {
        setAlerts(true);
        toast.success("ลบข้อมูลเรียบร้อย");
        setInterval(() => {
          navigate(0);
        }, 1000);
      } else {
        setAlerts(true);
        toast.error("ไม่สามารถลบข้อมูลได้");
      }

      // navigate(0);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        dispatch(logout());
        navigate("/notfound404", {
          state: {
            statusCode: err.response.status,
            txt: err.response.data,
          },
        });
      } else if (err.response.status === 404) {
        dispatch(logout());
        navigate("/notfound404", {
          state: {
            statusCode: err.response.status,
            txt: err.response.data,
          },
        });
      }
      console.log("getPubrelContents: ", err);
    });
  }else{

  }
  setOpenConfirm(false);
}
// const filteredDataip = getIps.map(item => {
//   if (item.status === 0) {
//       return {...item, status: 1};
//   }
//   return item;
// })



  const handleChanges = () => {
   
    // setClickUpDateAccess((prev) => !prev);
    setClickUpDateAccess(!clickUpDateAccess);
    if(clickUpDateAccess  === false){
      // setClickUpDateAccess(!clickUpDateAccess);
      // console.log("t")
      getIps.forEach(item => {
          if (item.ipaddr !== ipaddress) {
            item.status = 0;
          }
        });
     
    var configips = {
      method: "PUT",
      url: process.env.REACT_APP_API_URL + `/updateIps`,
      headers: {
        authtoken: "bearer " + token,
      },
      data: {
        filteredDataip: getIps,
       
      },
    };

axios(configips)
      .then((res) => {
        // console.log(res.data)
        if (res.data === "ok200") {
          setAlerts(true);
          toast.success("แก้ไขสถานะการใช้งานเรียบร้อย");
          // setInterval(() => {
          //   navigate(0);
          // }, 1000);
        } else {
          setAlerts(true);
          toast.error("ไม่สามารถแก้ไขสถานะการใช้งาน");
        }
    
        // navigate(0);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: {
              statusCode: err.response.status,
              txt: err.response.data,
            },
          });
        }
        console.log("getPubrelContents: ", err);
      });


    }else{
      // setClickUpDateAccess(!clickUpDateAccess);
      // console.log("f")

      getIps.forEach(item => {
        item.status = 1;
      });
   
  var configipss = {
    method: "PUT",
    url: process.env.REACT_APP_API_URL + `/updateIps`,
    headers: {
      authtoken: "bearer " + token,
    },
    data: {
      filteredDataip: getIps,
     
    },
  };

axios(configipss)
    .then((res) => {
      // console.log(res.data)
      if (res.data === "ok200") {
        setAlerts(true);
        toast.success("แก้ไขสถานะการใช้งานเรียบร้อย");
        // setInterval(() => {
        //   navigate(0);
        // }, 1000);
      } else {
        setAlerts(true);
        toast.error("ไม่สามารถแก้ไขสถานะการใช้งาน");
      }
  
      // navigate(0);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        dispatch(logout());
        navigate("/notfound404", {
          state: {
            statusCode: err.response.status,
            txt: err.response.data,
          },
        });
      } else if (err.response.status === 404) {
        dispatch(logout());
        navigate("/notfound404", {
          state: {
            statusCode: err.response.status,
            txt: err.response.data,
          },
        });
      }
      console.log("getPubrelContents: ", err);
    });



    }
 

    
  };


  
  const handleClose = () => {
    setOpen(false);
  };

  const handleAddip = () => {

    const isValid = /^[0-9.]+$/.test(ipaddr); 

    if (office === "" || ipaddr === "") {
      setAlerts(true);
      toast.error("กรุณากรอกหน่วยงาน หรือIP Address");
    } else if(!isValid){
      setAlerts(true);
      toast.error("กรุณากรอกIP Addressที่มีตัวเลขกับ.");
    } else {
      var configs = {
        method: "POST",
        url: process.env.REACT_APP_API_URL + `/AddIps`,
        headers: {
          authtoken: "bearer " + token,
        },
        data: {
          office: office,
          ipaddr: ipaddr,
        },
      };

      axios(configs)
        .then((res) => {
          // console.log(res.data)
          if (res.data === "ok200") {
            setAlerts(true);
            toast.success("บันทึกipเรียบร้อย");
            setInterval(() => {
              navigate(0);
            }, 1000);
          } else {
            setAlerts(true);
            toast.error("ไม่สามารถบันทึกipได้");
          }

          // navigate(0);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(logout());
            navigate("/notfound404", {
              state: {
                statusCode: err.response.status,
                txt: err.response.data,
              },
            });
          } else if (err.response.status === 404) {
            dispatch(logout());
            navigate("/notfound404", {
              state: {
                statusCode: err.response.status,
                txt: err.response.data,
              },
            });
          }
          console.log("getPubrelContents: ", err);
        });
    }
  };

  function QuickSearchToolbar() {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
        />
      </Box>
    );
  }

  const ButtonDownLoad = styled(Button)(({ theme }) => ({
    // color: theme.palette.getContrastText(green[50]),
    color: green[50],
    backgroundColor: green[700],
    borderColor: green[400],
    borderWidth: "2px",
    "&:hover": {
      backgroundColor: green[500],
      borderColor: green[700],
      borderWidth: "2px",
    },
  }));

  useEffect(() => {
    const newChecked = result ? true : false;
    setClickUpDateAccess(newChecked);
    var config = {
      method: "GET",
      url: process.env.REACT_APP_API_URL + "/getIps",
      headers: {
        authtoken: "bearer " + token,
      },
    };
    axios(config)
      .then((res) => {
        setGetIps(res.data);
        // console.log("data: ",res.data);
        const ipStatusObj = {};
        res.data.forEach((ip) => {
          ipStatusObj[ip.ipaddr] = ip.status === 0 ? false : true;
        });
        setIpStatus(ipStatusObj);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        }
        console.log("getPubrelContents: ", err);
      });

}, [result,checkstatus]);


  useEffect(() => {
    var config = {
      method: "GET",
      url: process.env.REACT_APP_API_URL + "/getLogIp",
      headers: {
        authtoken: "bearer " + token,
      },
    };
    axios(config)
      .then((res) => {
        setGetLogIps(res.data);
        // console.log("data: ",res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        }
        console.log("getPubrelContents: ", err);
      });
  }, []);






  useEffect(() => {

    const newChecked = checked ? false : true;
    setClickUpDate(newChecked);

    var config = {
      method: "GET",
      url: process.env.REACT_APP_API_URL + "/getAccesslog",
      headers: {
        authtoken: "bearer " + token,
      },
    };
    axios(config)
      .then((res) => {
        setGetAccess(res.data);
        // console.log("data: ",res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        } else if (err.response.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        }
        console.log("getPubrelContents: ", err);
      });

    

  }, [checked]);

  const handleClickOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(getlogIps);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DataGrid Data');
    XLSX.writeFile(workbook, 'ข้อมูลการเข้าใช้ระบบ.xlsx');
  };

  return (
    <>
      {alerts ? (
        <ToastContainer draggable={false} transition={Zoom} autoClose={3000} />
      ) : (
        <></>
      )}
      ยินดีต้อนรับ {userLogin.rank} {userLogin.fname} {userLogin.lname}
      {/* {" "}
      {ipaddress} */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#EEEEEE",
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent:'space-between'
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", marginLeft: "50px" }}
          >
            <p>สถานะเว็บไซต์</p>
            {/* <GreenSwitch  defaultChecked /> */}
            <FormControlLabel
              sx={{ margin: "5px" }}
              control={
                <GreenSwitch   checked={clickUpDate} onChange={handleChange} />
              }
              label={clickUpDate === false ? "ปิด" : "เปิด"}
            />
            <p>
              {clickUpDate === false
                ? `:ขออภัย กำลังปรับปรุงเว็บไซต์ (อนุญาตเฉพาะผู้คุมสอบ
                  ผู้บังคับบัญชา ผู้ดูแลระบบ Login เข้าสู่ระบบได้เท่านั้น)`
                : ""}
            </p>
          </Box>
          <Box  sx={{ display: "flex", alignItems: "center",justifyContent:'center' }}>
            
            <FileReaderComponent />

           <DownloadTxtButtonComponent />
          </Box>
        </Box>
        <br />
        <Box
          sx={{
            backgroundColor: "#EEEEEE",
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", marginLeft: "50px" }}
          >
            <p>ควบคุมการเข้าถึง</p>
            <FormControlLabel
              sx={{ margin: "5px" }}
              control={
    
                <GreenSwitch checked={clickUpDateAccess} onChange={handleChanges} />
              }
            
              // label={result === false ? "ปิด ควบคุมการเข้าสู่ระบบในบางเวลา เช่น การสอบรายการสำคัญๆอนุญาตให้ผู้เข้าสอบอยู่ในระบบเท่านั้น" : "เปิด ควบคุมการเข้าสู่ระบบในบางเวลา เช่น การสอบรายการสำคัญๆอนุญาตให้ผู้เข้าสอบอยู่ในระบบเท่านั้น"}
            />
            <p style={{fontWeight:'bold'}}>{result === false ? "ปิด ควบคุมการเข้าสู่ระบบในบางเวลา เช่น การสอบรายการสำคัญๆอนุญาตให้ผู้เข้าสอบอยู่ในระบบเท่านั้น" : "เปิด ควบคุมการเข้าสู่ระบบในบางเวลา เช่น การสอบรายการสำคัญๆอนุญาตให้ผู้เข้าสอบอยู่ในระบบเท่านั้น"}</p>
          </Box>

          <Box
            sx={{ display: "flex", alignItems: "center", marginLeft: "50px" }}
          >
            <p>อนุญาตเฉพาะ IP Address</p>
            <Button
              sx={{ marginLeft: "50px" }}
              variant="contained"
              onClick={handleClickOpen}
            >
              เพิ่มการอนุญาต
            </Button>
            <Dialog
            // fullWidth="fullWidth"
            maxWidth="md"
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"เพิ่มการอนุญาต IP Address"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Box sx={{ padding: "10px" ,display:'flex',justifyContent:'center'}}>
                    <TextField
                      id="outlined-basic"
                      onChange={handleChangeoffice}
                      label="หน่วยงาน"
                      variant="outlined"
                    />
                    <TextField
  id="outlined-basic"
  onChange={handleChangeipaddr}
  label="IP Address"
  variant="outlined"
  sx={{ marginLeft: "10px" }}
  inputProps={{
    pattern: "[0-9.]*", // รับเฉพาะตัวเลขและจุด
  }}
/>

           { /*
                    <TextField
                 
                      id="outlined-basic"
                      onChange={handleChangeipaddr}
                      label="IP Address"
                      variant="outlined"
                      sx={{ marginLeft: "10px" }}
            />*/}
                    {/* </Box> */}
                    
                  </Box>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" onClick={handleAddip}>
                  บันทึก
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              getRowId={(row) => row.ipaddr}
              rows={getIps}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              initialState={{
                filter: {
                  filterModel: {
                    items: [],
                    quickFilterLogicOperator: GridLinkOperator.Or,
                  },
                },
              }}
              components={{ Toolbar: QuickSearchToolbar }}
            />
          </div>
        </Box>
        <br />
        <Box
          sx={{
            backgroundColor: "#EEEEEE",
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "50px",
              padding: "10px",
            }}
          >
            <p>บันทึกเข้าสู่ระบบ</p>
            <ButtonDownLoad
              startIcon={<ArrowDownwardIcon />}
              sx={{ marginLeft: "50px" }}
              variant="contained"
              onClick={handleExport}
            >
              ดาวโหลด
            </ButtonDownLoad>
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: 16 }}
                startIcon={<DeleteForeverIcon />}
                onClick={handleClickOpenConfirm}
                // onClick={(event) =>
                //   handleDeleteLog(event, "Delete")
                // }
              >
                ลบการบันทึก
              </Button>
            </ThemeProvider>
            <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"ยืนยันในการลบบันทึกข้อมูลในการเข้าใช้ระบบทั้งหมด"}
        </DialogTitle>
        <DialogActions>
          <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: 16 }}
                startIcon={<DeleteForeverIcon />}
               onClick={(event) =>
                  handleDeleteLog(event, "Delete")
                }
              >
                ยืนยันลบการบันทึก
              </Button>
            </ThemeProvider>
        </DialogActions>
      </Dialog>
          </Box>
          <Box>
            <div style={{ height: 400, width: "100%" }}>
              <DataGrid
              getRowId={(row) => row.usagerecordid}
                rows={getlogIps}
                columns={columnsSave}
                pageSize={5}
                rowsPerPageOptions={[5]}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: QuickSearchToolbar }}
              />
            </div>
          </Box>
        </Box>
      </Box>
      <DrawerHeader />
      {/* <Footer />   */}
    </>
  );
}

export default ContentPageSettingWeb;
